// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__NWt7g","container":"Contact_container__cFl-R"};